import React from "react";
import { connect } from "react-redux";
import { Box, Button, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useHistory } from "react-router-dom";
import { homeActions } from "actions";
import { handleProductSelect } from "pages/home/CommonFunctions";

const RecentSearchButton = styled((props) => (
  <Button
    endIcon={
      <ChevronRightIcon sx={{ color: `${props.arrowColor}`, fontSize: 30 }} />
    }
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  textTransform: "none",
  backgroundColor: "#fff",
  color: theme.palette.primary.main,
  boxShadow: 3,
  minHeight: "66px",
  textAlign: "left",
  width: "100%",
  borderRadius: "8px",
  borderTopLeftRadius: "2px",
  borderBottomLeftRadius: "2px",
  justifyContent: "space-between",
  "&:hover": {
    backgroundColor: "#fff",
  },
}));

const RecentSearches = (props) => {
  const {
    selectedInsurance,
    saveSelectedProduct,
    resetData,
    recentList,
    savedevicelocation,
    setCurrentLocation,
    organizationInfo,
  } = props;
  const history = useHistory();

  const onProductSelect = (item) => {
    if (item) {
      const params = {
        item,
        selectedInsurance,
        saveSelectedProduct,
        resetData,
        history,
        changeView: true,
        isFromHomeGauge: true,
        savedevicelocation,
        setCurrentLocation,
      };
      handleProductSelect(params);
    }
  };

  return (
    <Box className="top-and-recent-box">
      <Grid container direction="row" spacing={2}>
        {recentList && recentList.length
          ? recentList.slice(0, 9).map((product) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={product.productName}
                  onClick={() => onProductSelect(product)}
                >
                  <Box
                    sx={{
                      backgroundImage: `linear-gradient(to bottom, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color}, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color} 25%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color} 60%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color});`,
                      paddingLeft: "8.2px",
                      borderRadius: "8px",
                    }}
                  >
                    <RecentSearchButton
                      arrowColor={`${organizationInfo?.colorSchemeJson?.primaryButtonColor}`}
                      variant="contained"
                    >
                      <Typography
                        variant="h3LatoMedium"
                        sx={{ color: "#121212", letterSpacing: "0.45px" }}
                      >
                        {product.productName}
                      </Typography>
                    </RecentSearchButton>
                  </Box>
                </Grid>
              );
            })
          : null}
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedInsurance: state.insuranceList.selectedInsurance,
    isProgress: state.topProducts.isProgress,
    recentList: state.recentSearch.data,
    organizationInfo: state.organizationInfo.data || {},
  };
};

const mapDispatchToProps = {
  getRecentSearch: () => homeActions.getRecentSearchList(),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  resetData: (value) => homeActions.resetData(value),
  savedevicelocation: (value) => homeActions.savedevicelocation(value),
  setCurrentLocation: (value) => homeActions.setCurrentLocation(value),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentSearches);
